
import React from 'react';
import BaseChart from './common/BaseChart';
import BarChartComponent from './common/BarChartComponent';
import ChartSkeleton from '../common/ChartSkeleton';

interface TimeDistributionChartProps {
  timeStats: any[];
  loading: boolean;
  exportCSV: (data: any[], filename: string) => void;
}

const TimeDistributionChart = React.memo(({ 
  timeStats, 
  loading, 
  exportCSV 
}: TimeDistributionChartProps) => {
  const processedData = React.useMemo(() => {
    return timeStats.map(item => ({
      ...item,
      hour_label: `${String(item.hour).padStart(2, '0')}:00`
    }));
  }, [timeStats]);

  if (loading) {
    return (
      <ChartSkeleton 
        title="Time Distribution"
        description="Activity distribution by hour of day"
        height={400}
        type="bar"
      />
    );
  }

  return (
    <BaseChart
      title="Time Distribution"
      description="Activity distribution by hour of day"
      data={processedData}
      loading={false}
      exportCSV={exportCSV}
      exportFilename="time_stats"
      chartType="bar"
    >
      <BarChartComponent
        data={processedData}
        dataKey="count"
        nameKey="hour_label"
        color="#06b6d4"
        formatter={(value) => [`${value}`, 'Events']}
        angle={-45}
        margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
        enableMultilineLabels={false}
      />
    </BaseChart>
  );
});

TimeDistributionChart.displayName = 'TimeDistributionChart';

export default TimeDistributionChart;
